/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
import React, { Component } from "react";
import * as d3 from "d3";
import "../css/Tree.css";

export default class Tree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orientation:"horizontal",
      dimensions: {
        x: 0,
        y: 0
      },
      draggin: false,
      translateTree: {
        x: 0,
        y: 0
      },
      direction: {
        oldX: 0,
        oldY: 0
      },
      scale: 1
    };
    this.renderTree = this.renderTree.bind(this);
    this.toggle = this.toggle.bind(this);
    this.updateTree = this.updateTree.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateTree);
    var treeContainer = this.refs.tree;
    const dimensions = treeContainer.getBoundingClientRect();
    //const tree = d3.tree().nodeSize([100, 100]).separation(100);
    const tree = d3.tree().nodeSize([100, 100]);

    const root = d3.hierarchy(this.props.treeData, function(d) {
      return d.children;
    });

    const treeDimensions = tree(root);

    this.setState(
      {
        root,
        dimensions: {
          x: dimensions.width,
          y: dimensions.height - 10
        },
        treeDimensions,
        active: true
      },
      () => this.renderTree(treeContainer)
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.treeData !== this.props.treeData) {
      var treeContainer = this.refs.tree;
      const dimensions = treeContainer.getBoundingClientRect();

      const tree = d3.tree().nodeSize([100, 100]);

      //const tree = d3.tree().separation(100);
      const root = d3.hierarchy(this.props.treeData, function(d) {
        return d.children;
      });

      const treeDimensions = tree(root);

      this.setState(
        {
          root,
          dimensions: {
            x: dimensions.width,
            y: dimensions.height - 10
          },
          treeDimensions
        },
        () => this.updateTree()
      );
    }
  }




  updateTree() {
    const dimensions = this.state.dimensions;
    dimensions.x = window.innerWidth;
    dimensions.y = window.innerHeight - 200;

    this.setState({
      dimensions
    });

    //const tree = d3.tree().nodeSize([100, 100]).separation(100);
    const tree = d3.tree().nodeSize([100, 100]);
    const treeDimensions = tree(this.state.root);

    this.setState({
      treeDimensions
    });



    var svg = d3.select(this.refs.tree);

    var zoom = d3.zoom()
        .on('zoom', function() {
          canvas.attr('transform', d3.event.transform);
        })

    d3.select('#zoom-in').on('click', function() {
      // Smooth zooming
      zoom.scaleBy(svg.transition().duration(750), 1.3);
    });

    d3.select('#zoom-out').on('click', function() {
      // Ordinal zooming
      zoom.scaleBy(svg, 1 / 1.3);
    });
    var canvas = svg
      .select("svg")
        .call(zoom)
      .attr("class", "svg")
      .attr("width", this.state.dimensions.x)
      .attr("height", this.state.dimensions.y)
      .on("mousedown", () => {
        this.setState({ draggin: true });
      })
      .on("touchstart", () => {
        d3.event.preventDefault();
        var direction = this.state.direction;
        direction.oldX = d3.event.touches[0].clientX;
        direction.oldY = d3.event.touches[0].clientY;
        this.setState({ draggin: true, direction });
      })
      .on("mousemove", () => {
        var direction;
        if (this.state.draggin) {
          var translateTree = this.state.translateTree;
          direction = this.state.direction;

          if (d3.event.clientX > direction.oldX) {
            translateTree.x += d3.event.clientX - direction.oldX;
          } else {
            translateTree.x -= direction.oldX - d3.event.clientX;
          }

          if (d3.event.clientX > direction.oldX) {
            translateTree.y += d3.event.clientY - direction.oldY;
          } else {
            translateTree.y -= direction.oldY - d3.event.clientY;
          }

          direction.oldX = d3.event.clientX;
          direction.oldY = d3.event.clientY;

          this.setState({
            direction,
            translateTree
          });

          this.updateTree();
        } else {
          direction = this.state.direction;
          direction.oldX = d3.event.clientX;
          direction.oldY = d3.event.clientY;
          this.setState({
            direction
          });
        }
      })
      .on("touchmove", () => {
        d3.event.preventDefault();
        var direction;
        if (this.state.draggin) {
          var translateTree = this.state.translateTree;
          direction = this.state.direction;
          if (d3.event.touches[0].clientX > direction.oldX) {
            translateTree.x += d3.event.touches[0].clientX - direction.oldX;
          } else {
            translateTree.x -= direction.oldX - d3.event.touches[0].clientX;
          }

          if (d3.event.touches[0].clientY > direction.oldY) {
            translateTree.y += d3.event.touches[0].clientY - direction.oldY;
          } else {
            translateTree.y -= direction.oldY - d3.event.touches[0].clientY;
          }

          direction.oldX = d3.event.touches[0].clientX;
          direction.oldY = d3.event.touches[0].clientY;

          this.setState({
            direction,
            translateTree
          });

          this.updateTree();
        }
      })
      .on("mouseup", () => {
        this.setState({ draggin: false });
      })
      .on("mouseleave", () => {
        this.setState({ draggin: false });
      })
      .on("touchend", () => {
        this.setState({ draggin: false });
      })
      .on("touchcancel", () => {
        this.setState({ draggin: false });
      })
      .on("touchleave", () => {
        this.setState({ draggin: false });
      })
      .on("wheel", () => {
        var scale = this.state.scale;
        if (d3.event.deltaY > 0 && scale < 8) scale += 0.1;
        else if (d3.event.deltaY < 0 && scale > 0.5) scale -= 0.1;
        this.setState({ scale });
        this.updateTree();
      })
      .on("gestureend", () => {
        var scale = this.state.scale;
        if (d3.event.scale > 1 && scale < 8) scale += 0.1;
        else if (d3.event.scale < 1 && scale > 0.5) scale -= 0.1;

        this.setState({ scale });
        this.updateTree();
      })
      .select("g")
    canvas.selectAll("*").remove();
    var link = d3
      .linkVertical()
      .x(function(d) {
        return d.x;
      })
      .y(function(d) {
        return d.y;
      });

    this.state.treeDimensions.each(node => {
      node.x += this.state.dimensions.x / 2;
      node.y += 30;
      var classes;
      if (node.data.decision === null && !node.data.leaf) {
        if (this.props.solution === "correct") {
          classes = node.data.visited ? "node visited" : "node";
        } else if (this.props.solution === "incorrect") {
          classes = node.data.visited ? "node visited-incorrect" : "node";
        } else {
          classes = node.data.visited ? "node visited-unknown" : "node";
        }
        canvas
          .append("circle")
          .on("click", () => {
            this.toggle(node);
          })
          .on("touchstart", () => {
            d3.event.preventDefault();
            this.toggle(node);
          })
          .attr("class", classes)
          .attr("r", 15)
          .attr("transform", "translate(" + node.x + "," + node.y + ")");
        if (this.props.solution === "correct") {
          classes = node.data.visited ? "node-text visited" : "node-text";
        } else if (this.props.solution === "incorrect") {
          classes = node.data.visited
            ? "node-text visited-incorrect"
            : "node-text";
        } else {
          classes = node.data.visited
            ? "node-text visited-unknown"
            : "node-text";
        }

        if (node.data.name.length > 10) {
          var splitted = node.data.name.split(" ");
        }
        if (!splitted) {
          canvas
            .append("text")
            .attr("class", classes)
            .attr(
              "transform",
              "translate(" + (node.x + 20) + "," + node.y + ")"
            )
            .text(node.data.name);
        } else {
          for (var i = 0; i < splitted.length; i++) {
            canvas
              .append("text")
              .attr("class", classes)
              .attr(
                "transform",
                "translate(" +
                  (node.x + 20) +
                  "," +
                  (node.y - 20 + 20 * i) +
                  ")"
              )
              .text(splitted[i]);
          }
        }
      } else if (node.data.leaf) {
        if (this.props.solution === "correct") {
          classes = node.data.visited ? "leaf visited" : "leaf";
        } else if (this.props.solution === "incorrect") {
          classes = node.data.visited ? "leaf visited-incorrect" : "leaf";
        } else {
          classes = node.data.visited ? "leaf visited-unknown" : "leaf";
        }
        canvas
          .append("rect")
          .attr("class", classes)
          .attr("width", 30)
          .attr("height", 30)
          .attr("transform", "translate(" + (node.x - 15) + "," + node.y + ")");
        if (this.props.solution === "correct") {
          classes = node.data.visited ? "leaf-text visited" : "leaf-text";
        } else if (this.props.solution === "incorrect") {
          classes = node.data.visited
            ? "leaf-text visited-incorrect"
            : "leaf-text";
        } else {
          classes = node.data.visited
            ? "leaf-text visited-unknown"
            : "leaf-text";
        }
        if (node.data.name.length > 10) {
          splitted = node.data.name.split(" ");
        }

        if (!splitted) {

          if(node.data.name.length > 10) {
            canvas
                .append("text")
                .attr("class", classes)
                .attr("textLength", 100)
                .attr("lengthAdjust", "spacingAndGlyphs")
                .attr(
                    "transform",
                    "translate(" + (node.x - 30) + "," + (node.y + 50) + ")"
                )
                .text(node.data.name);
          }else{
            canvas
                .append("text")
                .attr("class", classes)
                .attr("textLength", 100)
                .attr("lengthAdjust", "spacingAndGlyphs")
                .attr(
                    "transform",
                    "translate(" + (node.x - 30) + "," + (node.y + 50) + ")"
                )
                .text(node.data.name);
          }
        } else {
          for (i = 0; i < splitted.length; i++) {
            if(splitted[i].length >12) {
              canvas
                  .append("text")
                  .attr("class", classes)
                  .attr("textLength", 100)
                  .attr("lengthAdjust", "spacingAndGlyphs")
                  .attr(
                      "transform",
                      "translate(" +
                      (node.x - 30) +
                      "," +
                      (node.y + 50 + 20 * i) +
                      ")"
                  )
                  .text(splitted[i]);
            }else {
              canvas
                  .append("text")
                  .attr("class", classes)
                  .attr(
                      "transform",
                      "translate(" +
                      (node.x - 30) +
                      "," +
                      (node.y + 50 + 20 * i) +
                      ")"
                  )
                  .text(splitted[i]);
            }
          }
        }
      } else {
        if (this.props.solution === "correct") {
          classes = node.data.visited ? "link-text visited" : "link-text";
        } else if (this.props.solution === "incorrect") {
          classes = node.data.visited
            ? "link-text visited-incorrect"
            : "link-text";
        } else {
          classes = node.data.visited
            ? "link-text visited-unknown"
            : "link-text";
        }
        canvas
          .append("g")
          .attr(
            "transform",
            "translate(" + node.x + "," + node.y + ")rotate(-90)"
          )
          .append("text")
          .attr("class", classes)
          .attr("transform", "translate(-70, -10)")
          .text(node.data.decision);
      }
    });

    var width;
    var stroke;

    this.state.root.links().map(l => {
      width =
        (l.source.data.visited && l.target.data.children[0].visited) ||
        (!l.source.data.visited && l.target.data.visited)
          ? 4
          : 1;
      if (this.props.solution === "correct") {
        stroke =
          (l.source.data.visited && l.target.data.children[0].visited) ||
          (!l.source.data.visited && l.target.data.visited)
            ? "#4caf50"
            : "#283593";
      } else if (this.props.solution === "incorrect") {
        stroke =
          (l.source.data.visited && l.target.data.children[0].visited) ||
          (!l.source.data.visited && l.target.data.visited)
            ? "#f4511e"
            : "#283593";
      } else {
        stroke =
          (l.source.data.visited && l.target.data.children[0].visited) ||
          (!l.source.data.visited && l.target.data.visited)
            ? "#000000"
            : "#283593";
      }
      return canvas
        .append("g")
        .attr("fill", "none")
        .append("path")
        .attr("d", link(l))
        .attr("stroke", stroke)
        .attr("stroke-width", width);
    });
  }

  renderTree(treeContainer) {
    var canvas = d3
      .select(treeContainer)
      .append("svg")
      .attr("class", "svg")
      .attr("width", this.state.dimensions.x)
      .attr("height", this.state.dimensions.y)
      .on("mousedown", () => {
        this.setState({ draggin: true });
      })
      .on("touchstart", () => {
        d3.event.preventDefault();
        var direction = this.state.direction;
        direction.oldX = d3.event.touches[0].clientX;
        direction.oldY = d3.event.touches[0].clientY;
        this.setState({ draggin: true, direction });
      })
      .on("mousemove", () => {
        var direction;
        if (this.state.draggin) {
          var translateTree = this.state.translateTree;
          direction = this.state.direction;

          if (d3.event.clientX > direction.oldX) {
            translateTree.x += d3.event.clientX - direction.oldX;
          } else {
            translateTree.x -= direction.oldX - d3.event.clientX;
          }

          if (d3.event.clientY > direction.oldY) {
            translateTree.y += d3.event.clientY - direction.oldY;
          } else {
            translateTree.y -= direction.oldY - d3.event.clientY;
          }

          direction.oldX = d3.event.clientX;
          direction.oldY = d3.event.clientY;

          this.setState({
            direction,
            translateTree
          });

          this.updateTree();
        } else {
          direction = this.state.direction;
          direction.oldX = d3.event.clientX;
          direction.oldY = d3.event.clientY;
          this.setState({
            direction
          });
        }
      })
      .on("touchmove", () => {
        d3.event.preventDefault();
        var direction;
        if (this.state.draggin) {
          var translateTree = this.state.translateTree;
          direction = this.state.direction;
          if (d3.event.touches[0].clientX > direction.oldX) {
            translateTree.x += d3.event.touches[0].clientX - direction.oldX;
          } else {
            translateTree.x -= direction.oldX - d3.event.touches[0].clientX;
          }

          if (d3.event.touches[0].clientY > direction.oldY) {
            translateTree.y += d3.event.touches[0].clientY - direction.oldY;
          } else {
            translateTree.y -= direction.oldY - d3.event.touches[0].clientY;
          }

          direction.oldX = d3.event.touches[0].clientX;
          direction.oldY = d3.event.touches[0].clientY;

          this.setState({
            direction,
            translateTree
          });
          this.updateTree();
        }
      })
      .on("mouseup", () => {
        this.setState({ draggin: false });
      })
      .on("mouseleave", () => {
        this.setState({ draggin: false });
      })
      .on("touchend", () => {
        this.setState({ draggin: false });
      })
      .on("touchcancel", () => {
        this.setState({ draggin: false });
      })
      .on("touchleave", () => {
        this.setState({ draggin: false });
      })
      .on("wheel", () => {
        var scale = this.state.scale;
        if (d3.event.deltaY > 0 && scale < 8) scale += 0.1;
        else if (d3.event.deltaY < 0 && scale > 0.5) scale -= 0.1;

        this.setState({ scale });
        this.updateTree();
      })
      .on("gestureend", () => {
        var scale = this.state.scale;
        if (d3.event.scale > 1 && scale < 8) scale += 0.1;
        else if (d3.event.scale < 1 && scale > 0.5) scale -= 0.1;

        this.setState({ scale });
        this.updateTree();
      })
      .append("g")
      .attr(
        "transform",
        "scale(" +
          this.state.scale +
          ")translate(" +
          this.state.translateTree.x +
          "," +
          this.state.translateTree.y +
          ")"
      );

    var link = d3
      .linkVertical()
      .x(function(d) {
        return d.x;
      })
      .y(function(d) {
        return d.y;
      });

    this.state.treeDimensions.each(node => {
      node.x += this.state.dimensions.x / 2;
      node.y += 30;
      var classes;
      if (node.data.decision === null && !node.data.leaf) {
        if (this.props.solution === "correct") {
          classes = node.data.visited ? "node visited" : "node";
        } else if (this.props.solution === "incorrect") {
          classes = node.data.visited ? "node visited-incorrect" : "node";
        } else {
          classes = node.data.visited ? "node visited-unknown" : "node";
        }
        canvas
          .append("circle")
          .on("click", () => {
            this.toggle(node);
          })
          .on("touchstart", () => {
            d3.event.preventDefault();
            this.toggle(node);
          })
          .attr("class", classes)
          .attr("r", 15)
          .attr("transform", "translate(" + node.x + "," + node.y + ")");
        if (this.props.solution === "correct") {
          classes = node.data.visited ? "node-text visited" : "node-text";
        } else if (this.props.solution === "incorrect") {
          classes = node.data.visited
            ? "node-text visited-incorrect"
            : "node-text";
        } else {
          classes = node.data.visited
            ? "node-text visited-unknown"
            : "node-text";
        }

        if (node.data.name.length > 10) {
          var splitted = node.data.name.split(" ");
        }
        if (!splitted) {
          canvas
            .append("text")
            .attr("class", classes)
            .attr(
              "transform",
              "translate(" + (node.x + 20) + "," + node.y + ")"
            )
            .text(node.data.name);
        } else {
          for (var i = 0; i < splitted.length; i++) {
            canvas
              .append("text")
              .attr("class", classes)
              .attr(
                "transform",
                "translate(" +
                  (node.x + 20) +
                  "," +
                  (node.y - 20 + 20 * i) +
                  ")"
              )
              .text(splitted[i]);
          }
        }
      } else if (node.data.leaf) {
        if (this.props.solution === "correct") {
          classes = node.data.visited ? "leaf visited" : "leaf";
        } else if (this.props.solution === "incorrect") {
          classes = node.data.visited ? "leaf visited-incorrect" : "leaf";
        } else {
          classes = node.data.visited ? "leaf visited-unknown" : "leaf";
        }
        canvas
          .append("rect")
          .attr("width", 30)
          .attr("height", 30)
          .attr("class", classes)
          .attr("transform", "translate(" + (node.x - 15) + "," + node.y + ")");
        if (this.props.solution === "correct") {
          classes = node.data.visited ? "leaf-text visited" : "leaf-text";
        } else if (this.props.solution === "incorrect") {
          classes = node.data.visited
            ? "leaf-text visited-incorrect"
            : "leaf-text";
        } else {
          classes = node.data.visited
            ? "leaf-text visited-unknown"
            : "leaf-text";
        }
        if (node.data.name.length > 10) {
          splitted = node.data.name.split(" ");
        }

        if (!splitted) {
          if(node.data.name.toString().length >10) {
            canvas
                .append("text")
                .attr("class", classes)
                .attr("textLength", 100)
                .attr("lengthAdjust", "spacingAndGlyphs")
                .attr(
                    "transform",
                    "translate(" + (node.x - 30) + "," + (node.y + 50) + ")"
                )
                .text(node.data.name);
          }else{
            canvas
                .append("text")
                .attr("class", classes)
                .attr(
                    "transform",
                    "translate(" + (node.x - 30) + "," + (node.y + 50) + ")"
                )
                .text(node.data.name);
          }
        } else {
          for (i = 0; i < splitted.length; i++) {
            if(splitted[i].length>12) {
              canvas
                  .append("text")
                  .attr("class", classes)
                  .attr("textLength", 100)
                  .attr("lengthAdjust", "spacingAndGlyphs")
                  .attr(
                      "transform",
                      "translate(" +
                      (node.x - 30) +
                      "," +
                      (node.y + 50 + 20 * i) +
                      ")"
                  )
                  .text(splitted[i]);
            }else{
              canvas
                  .append("text")
                  .attr("class", classes)
                  .attr(
                      "transform",
                      "translate(" +
                      (node.x - 30) +
                      "," +
                      (node.y + 50 + 20 * i) +
                      ")"
                  )
                  .text(splitted[i]);
            }
          }
        }
      } else {
        if (this.props.solution === "correct") {
          classes = node.data.visited ? "link-text visited" : "link-text";
        } else if (this.props.solution === "incorrect") {
          classes = node.data.visited
            ? "link-text visited-incorrect"
            : "link-text";
        } else {
          classes = node.data.visited
            ? "link-text visited-unknown"
            : "link-text";
        }
        canvas
          .append("g")
          .attr(
            "transform",
            "translate(" + node.x + "," + node.y + ")rotate(-90)"
          )
          .append("text")
          .attr("class", classes)
          .attr("transform", "translate(-70, -10)")
          .text(node.data.decision);
      }
    });

    var width;
    var stroke;

    this.state.root.links().map(l => {
      width =
        (l.source.data.visited && l.target.data.children[0].visited) ||
        (!l.source.data.visited && l.target.data.visited)
          ? 4
          : 1;
      if (this.props.solution === "correct") {
        stroke =
          (l.source.data.visited && l.target.data.children[0].visited) ||
          (!l.source.data.visited && l.target.data.visited)
            ? "#4caf50"
            : "#283593";
      } else if (this.props.solution === "incorrect") {
        stroke =
          (l.source.data.visited && l.target.data.children[0].visited) ||
          (!l.source.data.visited && l.target.data.visited)
            ? "#f4511e"
            : "#283593";
      } else {
        stroke =
          (l.source.data.visited && l.target.data.children[0].visited) ||
          (!l.source.data.visited && l.target.data.visited)
            ? "#000000"
            : "#283593";
      }

      return canvas
        .append("g")
        .attr("fill", "none")
        .append("path")
        .attr("d", link(l))
        .attr("stroke", stroke)
        .attr("stroke-width", width);
    });
  }

  toggle(node) {
    var treeDimensions = this.state.treeDimensions;

    treeDimensions.each(child => {
      if (child === node) {
        if (child.children !== null) {
          child._children = child.children;
          child.children = null;
        } else {
          child.children = child._children;
          child._children = null;
        }
      }
    });

    this.setState({
      treeDimensions
    });

    this.updateTree();
  }

  render() {
    return <div ref="tree" className="tree" >
          </div>

  }
}
